import { IconButton, Stack, Badge, Popover, Box, MenuItem, FormControl, InputLabel, Select } from "@mui/material";
import FilterListIcon from "@mui/icons-material/FilterList";
import { useEffect, useState } from "react";
import api from "../services/api";


export default function TipoExpedienteFilter(props) {
  const [anchorEl, setAnchorEl] = useState(null);
  const [tipoDocumento, setTipoDocumento] = useState([]);
  const open = Boolean(anchorEl);

  const onClose = () => {
    setAnchorEl(null);
  };

  useEffect(() => {
    api.get('/expediente-docs')
      .then((res) => {
        setTipoDocumento(res.data.expedienteDocss)
      })
      .catch((err) => '')
  }, [])

  return (
    <Stack direction="row" alignItems="center" spacing={0.5}>
      <IconButton
        size="small"
        onClick={(e) => setAnchorEl(e.currentTarget)}
      >
        <Badge
          color="primary"
          variant="dot"
          invisible={!props.tipo}
        >
          <FilterListIcon fontSize="small" />
        </Badge>
      </IconButton>

      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={onClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Box p={2} minWidth={220}>
          <FormControl style={{ width: 200 }}>
            <InputLabel id="demo-simple-select-label">Tipo de Documento</InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              type="text"
              label="Tipo de Documento"
              size="small"
              name="tipoDoc"
              onChange={(e) => props.setDocumento(e.target.value)}
            >
              {tipoDocumento.map((documento) => (
                <MenuItem key={documento?._id} value={documento?._id}>
                  {documento?.designacao}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Box>
      </Popover>
    </Stack>
  );
};


